<template>
    <div class="contact">
        <TheHeader :headerIsFixed="true" />
        <div class="bg-img-warranty bg-center bg-cover pb-8 block clear pt-32 sm:pt-48 md:pt-64">
            <div class="text-center mx-6 sm:mx-auto sm:w-128 p-3 bg-black-transparent rounded-lg">
                <h1 class="text-white text-lg sm:text-2xl font-normal mb-2"
                    :class="{ 'search-extra-margin': searchIsFixed }">Find a Certified Auto Repair Center</h1>
                <TheShopsSearch />
                <div v-show="searchIsFixed" class="h-10 w-64 sm:w-96 md:w-120"></div>
                <p class="text-white mt-2">Search Thousands of Locations</p>
            </div>
        </div>
        <div class="sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl mx-3 sm:mx-auto p-3 sm:mt-4 text-sm sm:text-base">
            <section>
                <div class="flex flex-col md:flex-row">
                    <div class="items-center md:justify-left md:w-1/2 sm:mx-4 mb-4 sm:px-4">
                        <h2 class="text-xl mb-4">Certified Nationwide Warranty</h2>
                        <img src="../../assets/img/nationwide-warranty.png"
                            alt="The Certified Auto Repair Nationwide Warranty Logo"
                            class="w-32 h-24 mr-4 mb-1 float-left">
                        <p class="mt-3">Most repairs performed by a Certified Auto Repair center are backed by a
                            24 month/24,000 mile or 36 month/36,000 mile nationwide warranty.
                            Honored at more than 35,000 repair centers nationwide, the Certified Auto Repair
                            Nationwide Warranty has you covered - no matter where your travels take you.</p>
                        <ul class="views-list mt-3">
                            <li>A written, guaranteed Nationwide Warranty is Included FREE with every qualifying repair</li>
                            <li>Covers up to the original invoice amount of parts, labor, &amp; diagnostic time.</li>
                            <li>Backed by a nationwide network of professional repair centers.</li>
                            <li>As an additional benefit, all repairs come with complimentary, reimbursable roadside assistance.</li>
                        </ul>
                    </div>
                    <div class="sm:mx-4 md:justify-right md:w-1/2 mb-4">
                        <div class="flex items-center rounded-lg mb-4 px-4 py-4 sm:py-8 bg-white">
                            <IconPhone class="stroke-red-dark w-1/2 xs:w-1/4 h-24" viewBox="0 0 24 24"/>
                            <div class="flex flex-col text-base ml-6 xs:ml-8">
                                <h3 class="text-red-dark font-bold md:font-semibold md:text-lg">Contact Warranty Administrator</h3>
                                <p class="font-extrabold md:font-bold md:text-2xl">
                                    <a href="tel:+18004570019"
                                        class="no-underline">
                                        800 457 0019
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="md:mt-12">
                            <h2 class="text-xl">Need more details on how your Certified Nationwide Warranty works?</h2>
                            <p class="mt-3">
                                Select and view warranty and roadside assistance
                                PDFs below. Your local participating Certified Auto
                                Repair service center can tell you which warranty they
                                provide on their services.
                            </p>
                            <div>
                                <p class="my-2">
                                    <a
                                        :href="`${baseUrlForDocuments}/24_24_warranty_and_rsa_statement.pdf`"
                                        class="w-5/6 no-underline text-lg" target="_blank"
                                        title="24 Month / 24000 Mile Warranty"
                                        aria-label="24 Month / 24000 Mile Warranty PDF, opens in new tab"
                                    >
                                        24 Month / 24000 Mile Warranty
                                    </a>
                                </p>
                                <p class="my-2">
                                    <a
                                        :href="`${baseUrlForDocuments}/24_24_warranty_and_rsa_statement_span.pdf`"
                                        class="w-5/6 no-underline text-lg" target="_blank"
                                        title="Garantía de 24 Meses / 24000 Millas"
                                        aria-label="Garantía de 24 Meses / 24000 Millas, opens in new tab"
                                    >
                                        Garantía de 24 Meses / 24000 Millas
                                    </a>
                                </p>
                                <p class="my-2">
                                    <a
                                        :href="`${baseUrlForDocuments}/36_36_warranty_and_rsa_statement.pdf`"
                                        class="w-5/6 no-underline text-lg" target="_blank"
                                        title="36 Month / 36000 Mile Warranty"
                                        aria-label="36 Month / 36000 Mile Warranty PDF, opens in new tab"
                                    >
                                        36 Month / 36000 Mile Warranty
                                    </a>
                                </p>
                                <p class="my-2">
                                    <a
                                        :href="`${baseUrlForDocuments}/36_36_warranty_and_rsa_statement_span.pdf`"
                                        class="w-5/6 no-underline text-lg" target="_blank"
                                        title="Garantía de 36 Meses / 36000 Millas"
                                        aria-label="Garantía de 36 Meses / 36000 Millas, opens in new tab"
                                    >
                                        Garantía de 36 Meses / 36000 Millas
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <TheFooter></TheFooter>
    </div>
</template>

<script>
import TheHeader from '@/js/components/TheHeader.vue';
import TheShopsSearch from '@/js/components/TheShopsSearch.vue';
import TheFooter from '@/js/components/TheFooter.vue';
import IconPhone from 'icon/phone-call.svg';

export default {
    name: 'shops',
    components: {
        TheHeader,
        TheShopsSearch,
        TheFooter,
        IconPhone
    },
    data() {
        return {
            baseUrlForDocuments: 'https://images.firstcallonline.com/parts/img/documents/marketing/certified_auto_repair',
            searchIsFixed: false,
            toggles: {
                twelveMonthOpen: false,
                twentyFourMonthOpen: false,
                thirtySixMonthOpen: false,
                espanolOpen: false
            },
            buttonText: {
                twelveMonthText: '+',
                twentyFourMonthText: '+',
                thirtySixMonthText: '+',
                espanolText: '+'
            },
            smallScreen: false
        };
    },
    methods: {
        handleResize() {
            if (window.innerWidth < 900) {
                this.smallScreen = true;
            } else {
                this.smallScreen = false;
            }
        }
    },
    mounted() {
        this.handleResize();
        this.$root.$on('searchFixedTrue', () => { this.searchIsFixed = true; });
        this.$root.$on('searchFixedFalse', () => { this.searchIsFixed = false; });
    },
    created() {
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        anyWarrantiesOpen() {
            return this.toggles.twelveMonthOpen || this.toggles.twentyFourMonthOpen
                || this.toggles.thirtySixMonthOpen || this.toggles.espanolOpen;
        },
        twelveMonthList() {
            return Object.values(this.warrantyInfo).filter(item => item.twelveMonth === true);
        },
        twentyFourMonthList() {
            return Object.values(this.warrantyInfo).filter(item => item.twentyFourMonth === true);
        },
        thirtySixMonthList() {
            return Object.values(this.warrantyInfo).filter(item => item.thirtySixMonth === true);
        },
        espanolList() {
            return Object.values(this.warrantyInfo).filter(item => item.espanol === true);
        }
    }
};
</script>
